import { render, staticRenderFns } from "./Wrongly.vue?vue&type=template&id=1badcb7b&scoped=true"
import script from "./Wrongly.vue?vue&type=script&lang=js"
export * from "./Wrongly.vue?vue&type=script&lang=js"
import style0 from "./Wrongly.vue?vue&type=style&index=0&id=1badcb7b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1badcb7b",
  null
  
)

export default component.exports